import { onMounted, onActivated, getCurrentInstance, onUpdated } from 'vue';

import { checkIfAiChatApp, checkIfAppEnvironment } from '@/common/app';
import { PwaBridge } from '@/common/bridge';

export default function useSetPageTitle(name: string) {
    const { proxy } = getCurrentInstance() || {};

    async function setTitle() {
        if (checkIfAiChatApp()) {
            try {
                await PwaBridge.setTitle((proxy?.$root?.$t(name) as string) || '');
            } catch (err) {
                console.log(' set error', err);
            }
        }
    }

    onMounted(async () => {
        await setTitle();
    });

    onActivated(async () => {
        await setTitle();
    });

    onUpdated(async () => {
        await setTitle();
    });
}
